import { CarePlanEnum } from '../../../Enum/CarePlanEnum';
import { ItemConfig, LinkableItemType } from './types';

/**
 * Constants for CarePlanUpdateTwo component
 */

export const GOAL_STATUSES = [
    { value: CarePlanEnum.InProgress, label: 'In Progress' },
    { value: CarePlanEnum.Achieved, label: 'Achieved' },
    { value: CarePlanEnum.NotMet, label: 'Not Met' },
    { value: CarePlanEnum.Deleted, label: 'Deleted' },
] as const;

export const LINKABLE_ITEM_TYPES: LinkableItemType[] = ['strength', 'barrier', 'nextStep', 'plan', 'metric', 'schedulePlan'];

/**
 * Configuration for different item types including their display properties
 */
export const ITEM_CONFIGS: Record<LinkableItemType, ItemConfig> = {
    strength: {
        key: 'Strengths',
        label: 'Strengths',
        color: 'success.main',
    },
    barrier: {
        key: 'Barriers',
        label: 'Barriers',
        color: 'error.main',
    },
    nextStep: {
        key: 'NextSteps',
        label: 'Next Steps',
        color: 'secondary.main',
    },
    plan: {
        key: 'Plans',
        label: 'Plans',
        color: 'info.main',
    },
    metric: {
        key: 'Metrics',
        label: 'Metrics',
        color: 'info.main',
    },
    schedulePlan: {
        key: 'SchedulePlans',
        label: 'Schedule Plans',
        color: 'warning.main',
    },
};

/**
 * Progress item colors for different types
 */
export const PROGRESS_COLORS: Record<LinkableItemType, string> = {
    strength: '#1976d2',
    barrier: '#d32f2f',
    nextStep: '#7b1fa2',
    plan: '#0288d1',
    metric: '#388e3c',
    schedulePlan: '#fbc02d',
};
